import { ShellSnippet } from '@/shared/components/ShellSnippet'
import { s } from '@/features/integrations/guideStyles'
import type { GuideId } from '@/features/integrations/guides'

// ── Module Packaging ──────────────────────────────────────────────────────────
export function ModulePackagingGuide({ onSwitchGuide }: { onSwitchGuide: (id: GuideId) => void }) {
  return (
    <div>
      <h3 style={s.guideTitle}>Packaging Modules</h3>
      <p style={s.para}>
        A module is a flat folder of Terraform files, archived as a <code style={s.code}>.tar.gz</code>. More information on modules can be found in the <a href="https://developer.hashicorp.com/terraform/language/modules" target="_blank" rel="noopener noreferrer">Terraform documentation</a>.
        <br/>Get the layout and the archive right here, then head to{' '}
        <button style={s.linkBtn} onClick={() => onSwitchGuide('module-publishing')}>Publishing Module</button> to find out how to publish it.
      </p>

      <h3 style={s.subTitle}>1. Structure your module</h3>
      <p style={s.para}>
        Keep the module's <code style={s.code}>.tf</code> files in a flat folder. The folder is the
        module root - the archive must contain these files at its top level, not a parent directory.
      </p>
      <ShellSnippet
        code={`my-module/
  README.md
  main.tf
  variables.tf
  outputs.tf`}
        language="text"
      />

      <h3 style={s.subTitle}>2. Package as .tar.gz</h3>
      <p style={s.para}>
        Create a gzipped tarball of the module root. The <code style={s.code}>-C</code> flag changes
        into the folder so its contents sit at the archive's top level.
      </p>
      <ShellSnippet code={`tar -czf module.tar.gz -C ./my-module .`} language="bash" />

      <h3 style={s.subTitle}>Notes</h3>
      <ul style={s.list}>
        <li>The archive must be a <code style={s.code}>.tar.gz</code> of the module root - not a parent directory.</li>
        <li>Include a <code style={s.code}>README.md</code> - it renders on the module page in the registry.</li>
        <li>Don't bundle <code style={s.code}>.terraform/</code>, state files, or <code style={s.code}>.git/</code> - keep the archive to source files.</li>
        <li>The <a href="https://github.com/terramantle/modules-sample-mono-repo" target="_blank" rel="noopener noreferrer">github.com/terramantle/modules-sample-mono-repo</a> is the source for the `acme-demo` org modules and has an example CI publishing workflow.</li>
      </ul>
    </div>
  )
}
